import { render, staticRenderFns } from "./DashboardCajero.vue?vue&type=template&id=1a3da1b2"
import script from "./DashboardCajero.vue?vue&type=script&lang=js"
export * from "./DashboardCajero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports